
/**
 * 투표 결과의 선택지 정보
 */
export type VoteOnPoll200OptionsItemAllOf = {
  /** 선택지 고유 ID (백엔드에서 생성) */
  optionId?: string;
  /** 투표 선택지 텍스트 */
  text?: string;
  /** 해당 선택지의 득표수 */
  votes?: number;
};
